<template>
    <div id="products-category-list" class="page products-category-list">        
        <ProductsCategoryMenu />        
        <section>
            <div class="container-xl products-category-list__content">                
                <div v-if="getDataSuccess">
                    <div class="row ">
                        <div class="filterPanel-btn-mobil" @click="showFIlterPanel()">{{ lang('szuropanel_szuro')}} <span v-if="activeFiltersNum()>0">( {{activeFiltersNum()}} )</span></div>
                        <div class="col-12 col-md-3 filterPanel-wrap">   
                            <div class="filterPanel-wrap__title">                            
                                <div>{{ lang("szuropanel")}}</div>                      
                                <div class="filterPanel-wrap__close--mobile" @click="closeFIlterPanel()"></div>
                            </div>                        
                            <!-- active filterpanel -->                        
                            <div class="filterPanel filterPanel--active" v-if="filterPanelIsReady && hasAnyFilters('1')===true">
                                <div class="filterPanel--active__title">{{ lang("aktiv_szuropanel")}}</div>
                                <div class="filterPanel__block" v-for="(filter, filterIndex) in filterPanel" :key="filterIndex" :class="hasFilters(filter, '1')===true ? '' :  'hide'">
                                    <div class="group-name" v-if="hasFilters(filter, '1')===true">{{filter.filterGroupName}}</div>
                                    <div class="filter-block-wrap" v-if="hasFilters(filter, '1')===true">
                                        <div class="filter-name" v-for="(filterName, index) in filter.filters" :key="index" >
                                            <div v-if="parseInt(filterName.checked)===1" class="filter-name-row">
                                                <div>{{filterName.name}}</div>
                                                <div class="delFilter" @click="removeFromSelectedFilter(filterName)"></div>
                                            </div>                                        
                                        
                                        </div>                                    
                                    </div>                               
                                </div>
                                <button class="btn btn--green-border" @click="removeAllActiveFilters()"> {{ lang("osszes_szures_torlese")}}</button>
                                <div class="btn btn--green-full" @click="closeFIlterPanel()"> 
                                    {{ lang("szures")}}
                                </div>
                            </div>                       
                            <!-- filterpanel -->                        
                            <form class="filterPanel" v-if="filterPanelIsReady && hasAnyFilters('0')==true">
                                <div class="filterPanel__block" v-for="(filter, filterIndex) in filterPanel" :key="filterIndex" :class="hasFilters(filter, '0')===true ? '' :  'hide'">
                                    <div class="group-name" @click="toggleFilterBlockWrap()">{{filter.filterGroupName}}</div>
                                    <div class="filter-block-wrap"  v-if="hasFilters(filter, '0')===true">
                                        <div class="filter-name" v-for="(filterName, index) in filter.filters" :key="index" :class="(index > 4 ? 'hide hidedElement' : '' )">
                                            <div class="custom-control custom-checkbox" v-if="filter.filterGroupType=='checkbox' && parseInt(filterName.checked)===0">
                                                <input type="checkbox" class="custom-control-input" :id="filterName.name +'_' + index" true-value="1" false-value="0" v-model="filterName.checked"  />
                                                <label class="custom-control-label" :for="filterName.name +'_' + index" @click="selectedFilter(filterName.id)">{{filterName.name}}</label>
                                            </div> 
                                            <div class="custom-control custom-radio" v-else-if="filter.filterGroupType=='radio' && parseInt(filterName.checked)!=1" >
                                                <input type="radio" :name="filter.filterGroupName" class="custom-control-input" :id="filterName.name +'_' + index"  :value="1" v-model="filterName.checked" />
                                                <label class="custom-control-label" :for="filterName.name +'_' + index" @click="selectedFilter(filterName.id)">{{filterName.name}}</label>
                                            </div> 
                                        </div>
                                        <div class="filterPanel__block-show-more" v-if="filter.filters.length>5" @click="toggleBlockItems">{{ lang('szuropanel_tovabbiak_mutatasa') }} </div>
                                    </div>                               
                                </div>
                            </form>                                                              
                        </div>                     
                        <div class="col-12 col-md-9 products-category-list__list-wrap" >   
                            <h2>{{ currentCategoryName }}</h2>                        
                            <div class="products-category-list__list row" v-if="currentCategoryProducts.length > 0">
                                <div class="col-6 col-lg-4 product-item-wrap" v-for="product in currentCategoryProducts" :key="product.id + '_' + currentLangName()">                                   
                                      <ProductItem  
                                        :name="product.name" 
                                        :categoryId="product.category_id" 
                                        :product_slug="product.slug" 
                                        :srcset="itemSrcset(product)"  
                                        :src="itemSrc(product, 'w286h440')" 
                                        :id="product.id"
                                        :fixCategory="currentCategoryName"
                                        :imgPack="product.packImg"
                                    />  
                                </div>
                            </div>                                 
                            <div v-else>{{lang('nincs_talalat')}}</div>
                            <div v-html="extraText.description" v-if="currentProjectCategoryId == 11"></div>
                            
                        </div>                    
                    </div>                  
                </div>
                <div v-else class="row">
                    <div  class="col-12">
                        <Loading />
                    </div>
                </div> 
            </div>           
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import ProductItem from '@/components/pagesComponents/products/ProductItem.vue'
import ProductsCategoryMenu from '@/components/pagesComponents/products/ProductsCategoryMenu.vue'
import Loading from '@/components/layoutComponents/Loading.vue'
import $ from "jquery"

export default {
    data(){
        return {
            currentCategoryProducts: [],
            currentCategoryName: '',
            currentProjectCategoryId: '',
            filterPanel: [],            
            filterPanelIsReady: false,
            selectedFilterIds: [],
            getDataSuccess: false,
            currentCategoryMetas: {
                meta_description: null,
                meta_image: null,
                meta_keywords: null,
                meta_title: null
            },
            extraText: ''            
        }
    },
    components:{
        ProductItem,
        ProductsCategoryMenu,
        Loading        
    },
    computed:{
        productsCategory(){
            return this.$store.getters.getProducstCategory;             
        },
        currentProdCatSlug(){
            return this.$route.params.product_category_slug;
        }        
    },
    watch:{
        productsCategory: function(){                        
            this.getActualProductsList();                                    
        },
        // currentProdCatSlug: function(){
        //     this.getActualProductsList();
        // },
        $route: function(){            
            this.filterPanelIsReady = false 
            this.getDataSuccess = false              
            this.getActualProductsList();
            this.getExtraContent();
        },
        filterPanel: {
            deep: true,
            immediate: true,
            handler(){      
                this.$nextTick(function () {
                    if ($('.filterPanel').find('.filterPanel__block.hide:last-child').length > 0){
                        $('.filterPanel').find('.filterPanel__block.hide:last-child').prev().addClass('lastBlock')
                    } else {
                        $('.filterPanel').find('.filterPanel__block.lastBlock').removeClass('lastBlock')
                    }                     
                }.bind(this))   
                                                      
            }
        }         
    },
    methods:{
        getActualProductsList(){
            let _this = this
            
            if (this.productsCategory.length ) {
                let currentProjectCategorySlug = this.currentProdCatSlug;
                let currentProjectCategoryId = null;
                let currentProjectCategoryName = null;

                this.productsCategory.filter(item => {                
                    if (item.slug == currentProjectCategorySlug){
                        currentProjectCategoryId = item.category_id,
                        currentProjectCategoryName = item.name
                    }
                })                  
                
                this.currentProjectCategoryId = currentProjectCategoryId;
                
                axios.get(process.env.VUE_APP_BIFROST_API_URL + '/category/' + currentProjectCategoryId + '?relations=1&relations_params[information][where][0][0]=where&relations_params[information][where][0][1]=status&relations_params[information][where][0][2]=1&relations_params[information][order_by][0][0]=sort_order&relations_params[information][order_by][0][1]=asc&relations_params[information][order_by][1][0]=name&relations_params[information][order_by][1][1]=asc',{            
                    params:{
                        "language_id": this.$store.getters.getSelectedLang.id
                                            
                    }
                }).then(response => {
                    // console.log("termékek", response.data)
                    if (response.data.status == true ){                                            
                        //set category meta tags
                        if (response.data.category[0].meta_description != ''){
                            _this.currentCategoryMetas.meta_description = response.data.category[0].meta_description
                        } else {
                            _this.currentCategoryMetas.meta_description = null
                        }                       

                        if ( !response.data.category[0].meta_image ) {  
                            _this.currentCategoryMetas.meta_image = null
                        } else {
                            let meta_image_src = process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME + '/' + response.data.category[0].meta_image.path + '/' + response.data.category[0].meta_image.file_name
                            _this.currentCategoryMetas.meta_image = meta_image_src
                        }
                        
                        if (response.data.category[0].meta_keywords != ''){
                            _this.currentCategoryMetas.meta_keywords = response.data.category[0].meta_keywords
                        } else {
                            _this.currentCategoryMetas.meta_keywords = null
                        }
                        
                        if (response.data.category[0].meta_title != '') {
                            _this.currentCategoryMetas.meta_title = response.data.category[0].meta_title
                        } else {
                            _this.currentCategoryMetas.meta_title = null
                        }          
                        
                        _this.setCurrentMetaTags()

                        //set products
                        if (response.data.category[0].information){
                            this.currentCategoryProducts = [];
                             if (_this.$store.state.needPD){
                                for (var i=0; i <response.data.category[0].information.length ;i++)
                                {
                                    if (response.data.category[0].information[i].published_date <=  new Date().toISOString().slice(0, 19).replace('T', ' '))
                                          this.currentCategoryProducts .push(response.data.category[0].information[i]);
                                }
                                
                            }
                            else
                                this.currentCategoryProducts = response.data.category[0].information;
                            this.currentCategoryName = currentProjectCategoryName;
                            // this.getDataSuccess = true
                            this.getFilters();  
                        } else {                                                 
                            this.currentCategoryProducts = []
                            this.getDataSuccess = true
                            this.currentCategoryName = currentProjectCategoryName
                            this.filterPanel = []
                        }                                            
                    } else{
                        this.currentCategoryProducts = []
                        this.$router.push({name: '404-page'})
                    }                                                
                })
                .catch((err) => {
                    console.log(err)
                }); 
            }
            
        },
        getFilters(){
            var _this = this;            
            let productIds = []

            if (_this.currentCategoryProducts.length > 0){
                _this.currentCategoryProducts.forEach(item => {                             
                    productIds.push(item.id)               
                })
            }
       
            if (productIds.length > 0){
                var whereParams = productIds.join()            
            
                axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information?relations=1&where[0][0]=where_in&where[0][1]=id&where[0][2]=' + whereParams + '&order_by[0][0]=sort_order&order_by[0][1]=asc&order_by[1][0]=name&order_by[1][1]=asc',{
                    params:{
                        "language_id": this.$store.getters.getSelectedLang.id
                                            
                    }
                }).then(response => {
                    // console.log('getFilters', response.data);
                    if (response.data.status === true){
                        this.getFilterPanel(response.data);                
                    } else {
                        this.filterPanel = []
                    }
                    
                })
                .catch((err) => {
                    console.log(err)
                }); 
            }                        
            
        },
        getFilterPanel(informations){
            
            var infoArray = informations.information;
            var filterPanel = []                        

            infoArray.forEach(item => {
                if (item.filter){
                    item.filter.forEach(element => {
                        if (parseInt(element.show_on_filterpanel) === 1) {                    
                            let isFilterGroup = filterPanel.find(  i => i.filterGroupId == element.filter_group_id)
                            if ( isFilterGroup) {                            
                                let isFilter = isFilterGroup.filters.find( e => e.id == element.filter_id)
                                if (!isFilter){
                                    isFilterGroup.filters.push(
                                        {                        
                                            id: element.filter_id,
                                            name: element.name,
                                            sort_order: element.sort_order,
                                            checked: "0"
                                        }
                                    )
                                }                        
                            } else {                                
                                filterPanel.push({
                                    filterGroupId: element.filter_group_id,
                                    filterGroupName: null,
                                    filterGroupType:"",
                                    filters: [{
                                        id: element.filter_id,
                                        name: element.name,
                                        sort_order: element.sort_order,
                                        checked: "0"
                                    }]
                                })                                              
                            }
                        }
                    
                    })
                }
               
            })                             

            filterPanel.forEach(item => {
                item.filters = item.filters.sort(this.sortFilters)
            })
            
            this.filterPanel = filterPanel
            this.getFilterGroupNamesAndType();            
                                   
        },
        sortFilters(a,b){
            var sortOrderA = parseInt(a.sort_order);
            var sortOrderB = parseInt(b.sort_order);                         

            let comparison = 0;
            if (sortOrderA > sortOrderB) {
                comparison = 1;
            } else if (sortOrderA < sortOrderB) {
                comparison = -1;
            }            
            
            return comparison;
        },
        getExtraContent (){

            var _this = this;
            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information?where[0][0]=where&where[0][1]=id&where[0][2]=330"',{
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id
                                         
                }
            }).then(response => {
                // console.log('getFilterGroupNames', response.data.filter_group);
                if (response.data.status === true) {
                  _this.extraText = response.data.information[0]
                }   
                
            })
            .catch((err) => {
                console.log(err)
            });          
        },
        getFilterGroupNamesAndType(){
            let _this = this;

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/filter_group?relations=1"',{
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id
                                         
                }
            }).then(response => {
                // console.log('getFilterGroupNames', response.data.filter_group);
                if (response.data.status === true) {
                    let filtersGroupName = response.data.filter_group;
                    _this.filterPanel.forEach(item => {   
                        let currentGroup =  filtersGroupName.find(  i => i.filter_group_id == item.filterGroupId)                
                        item.filterGroupName = currentGroup.name
                        item.filterGroupType = currentGroup.type,
                        item.filterGroupSortOrder = currentGroup.sort_order
                    })   

                    _this.filterPanel = _this.filterPanel.sort(this.sortFiltersGroup);

                    if (_this.filterPanel.length > 0) {
                        setTimeout(()=>{
                            _this.filterPanelIsReady = true
                            _this.getDataSuccess = true
                        }, 500)
                        
                    }
                }   
                
            })
            .catch((err) => {
                console.log(err)
            });                                   
           
        },            
        sortFiltersGroup(a,b){
            var sortOrderA = parseInt(a.filterGroupSortOrder);
            var sortOrderB = parseInt(b.filterGroupSortOrder);            

            let comparison = 0;
            if (sortOrderA > sortOrderB) {
                comparison = 1;
            } else if (sortOrderA < sortOrderB) {
                comparison = -1;
            }            
            return comparison;
        },   
        toggleBlockItems(){
            var clickedItem = event.target   
            var _this = this;         

            $(clickedItem).closest('.filter-block-wrap').find('.hidedElement').each(function(){
                $(this).toggleClass("hide");
            })
            $(clickedItem).toggleClass('opened');            
            $(clickedItem).html(function(){
                if ($(this).hasClass('opened')){
                    return  _this.lang('szuropanel_kevesebb_mutatasa');
                } else {
                    return  _this.lang('szuropanel_tovabbiak_mutatasa');
                }
                
            }) 
        },
        selectedFilter(filterId){                        
            this.selectedFilterIds.push(filterId);          
            this.getFilteredProducts(this.selectedFilterIds)
        },
        removeFromSelectedFilter(filter){
            filter.checked = 0
            this.selectedFilterIds.splice(this.selectedFilterIds.indexOf(filter.id), 1);
            this.getFilteredProducts(this.selectedFilterIds)
        },
        getFilteredProducts(filterIds){            

            axios.post(process.env.VUE_APP_BIFROST_API_URL + '/helper/searchinformation', {
                    category_id: this.currentProjectCategoryId,
                    filters: filterIds
                },
                {
                    params:{
                        "language_id": this.$store.getters.getSelectedLang.id                         
                    }
                }
            ).then(response => {                                
                // console.log('filtered data', response.data)
                if (response.data.status === true) {
                    this.currentCategoryProducts = response.data.information;    
                    this.getPackImgs()
                } else {                    
                    this.currentCategoryProducts = []
                }                                
                        
            }) .catch(function (error) {                                                          
                console.log(error)
            });
        }, 
        hasFilters(filter, value){
            if ( filter.filters.find( i => i.checked == value ) ){                
                return true
            } else {                
                return false
            }
        },        
        hasAnyFilters(value){
            var filterNum = 0
            this.filterPanel.forEach( item => {
                if ( item.filters.find( i => i.checked == value )){
                    filterNum += 1                   
                } 
            })

            return filterNum > 0 ? true : false
        },
        showFIlterPanel(){
            $('.filterPanel-wrap').addClass('showFilterPanel');
        },
        closeFIlterPanel(){
            $('.filterPanel-wrap').removeClass('showFilterPanel');
        },
        activeFiltersNum(){
            let filtersNum = 0
            this.filterPanel.forEach(item => {
                item.filters.forEach(element => {
                    if ( parseInt(element.checked) === 1 ) {
                        filtersNum += 1
                    }
                })
            })

            return filtersNum
        },
        removeAllActiveFilters(){
            
            this.filterPanel.forEach(item => {
                item.filters.forEach(element => {
                    if ( parseInt(element.checked) === 1 ) {
                        element.checked = 0
                    }
                })
            })
            
            this.selectedFilterIds = []
            this.getFilteredProducts(this.selectedFilterIds)
            
            //if mobile
            $('.filterPanel-wrap').removeClass('showFilterPanel');
        },
        toggleFilterBlockWrap(){
            let clickedItem = event.target;

            $(clickedItem).toggleClass('closed')
            $(clickedItem).next().toggleClass("closed")
        },
        setCurrentMetaTags(){
            let _this = this            

            this.setMetaTags({
                title: _this.currentCategoryMetas.meta_title, 
                desc: _this.currentCategoryMetas.meta_description, 
                keywords: _this.currentCategoryMetas.meta_keywords, 
                ogType: 'products', 
                ogTitle: _this.currentCategoryMetas.meta_title,
                ogImage: _this.currentCategoryMetas.meta_image, 
                ogImageWidth: null, 
                ogImageHeight: null, 
                ogDesc: _this.currentCategoryMetas.meta_description
            })
        },
        stringEqual(string1, string2){   
            let distance = levenshteinDistance(string1, string2)                            

            function levenshteinDistance (s, t) {                
                
                if (!s.length || s.length == 0) return t.length;
                if (!t.length || t.length == 0) return s.length;                

                return Math.min(
                    levenshteinDistance(s.substr(1), t) + 1,
                    levenshteinDistance(t.substr(1), s) + 1,
                    levenshteinDistance(s.substr(1), t.substr(1)) + (s[0] !== t[0] ? 1 : 0)
                ) + 1;
                          
            }    
            
            return distance
        },       
        getPackImgs(){
            let packFilter = this.filterPanel.find(item => parseInt(item.filterGroupId) === 4)
            var checkedFilters = []
            // let _this = this

            //pack filter id = 4, if there is in the active filters, find the name of pack filters
            if ( packFilter !== undefined){                
                packFilter.filters.forEach( element => {
                    if ( parseInt(element.checked) === 1) {
                        checkedFilters.push(element.name)
                    }
                } )
            }

            // console.log("checkedFilters", checkedFilters)

            //find the good img
            this.currentCategoryProducts.forEach( item => {                
                if (item.information_image && item.information_image.length > 0) {                    
                    item.information_image.forEach( element => {                        
                        if ( checkedFilters.includes(element.name) ) {
                            //if the text is equal
                            if (checkedFilters.find( e => e == element.name)) {
                                item.packImg = element
                            }                                                   
                        }
                        // else - the text is not equal -- stringEqual need                 
                    })
                }
            })
        }        
    } ,
    created(){
         this.getActualProductsList();    
         this.$store.dispatch("setProducts_category");   
         this.getExtraContent();
         
        // console.log("checkPackString", this.stringEqual('160g üveg', '160g flakon') )
    }   
}
</script>